export default class KeepScrollPos {
  constructor () {
    this.positionY = 0;
  }

  savePosition () {
    this.positionY = window.pageYOffset;
  }

  applyPosition () {
    window.scrollTo(0, this.positionY);
  }
}
